export default __webpack_public_path__ + "static/media/signes.758f155a.svg";